<template>
  <div>

    <Head :title="form.name" />
    <div class="flex justify-start mb-8 max-w-3xl">
      <h1 class="mb-8 text-3xl font-bold">
        <Link class="text-indigo-400 hover:text-indigo-600" href="/organizations">Organizations</Link>
        <span class="text-indigo-400 font-medium">/</span>
        {{ form.name }}
      </h1>
      <img v-if="organization.logo" class="block ml-4 w-8 h-8 rounded-full" :src="organization.logo" />
    </div>
    <trashed-message v-if="organization.deleted_at" class="mb-6" @restore="restore">This organization has been deleted.
    </trashed-message>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="update">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input v-model="form.name" :error="form.errors.name" class="pb-8 pr-6 w-full lg:w-1/2" label="Name" />
          <text-input v-model="form.code" :error="form.errors.code" disabled class="pb-8 pr-6 w-full lg:w-1/2"
            label="Code" />
          <text-input v-model="form.urls" :error="form.errors.urls" class="pb-8 pr-6 w-full lg:w-1/2" label="URLS" />
          <select-input v-model="form.status" :error="form.errors.status" class="pb-8 pr-6 w-full lg:w-1/2"
            label="Status">
            <option :value="null" />
            <option>active</option>
            <option>inactive</option>
          </select-input>
          <text-input v-model="form.site_official" :error="form.errors.site_official" class="pb-8 pr-6 w-full lg:w-1/2"
            label="Site Oficial" />
          <text-input v-model="form.link_catalogo" :error="form.errors.link_catalogo" class="pb-8 pr-6 w-full lg:w-1/2"
            label="Link Catálogo" />
          <text-input v-model="form.link_materiais" :error="form.errors.link_catalogo" class="pb-8 pr-6 w-full lg:w-1/2"
            label="Link Materiais" />
          <text-input v-model="form.link_suporte" :error="form.errors.link_suporte" class="pb-8 pr-6 w-full lg:w-1/2"
            label="Link Suporte" />
          <select-input v-model="form.registration_type" :error="form.errors.registration_type"
            class="pb-8 pr-6 w-full lg:w-1/2" label="Tipo de Cadastro">
            <option :value="null" />
            <option value="simple">simples</option>
            <option value="complete">completo</option>
          </select-input>
          <select-input v-model="form.modelo_multinivel" :error="form.errors['modelo_multinivel']"
            class="pb-8 pr-6 w-full lg:w-1/2" label="Modelo Multinível">
            <option :value="null" />
            <option value="true">SIM</option>
            <option value="false">NÃO</option>
          </select-input>
          <text-input v-model="form.theme.primary_color" :error="form.errors['theme.primary_color']"
            class="pb-8 pr-6 w-full lg:w-1/2" label="Cor primaria" style="padding:0" type="color" />
          <text-input v-model="form.theme.degrade_color" :error="form.errors['theme.degrade_color']"
            class="pb-8 pr-6 w-full lg:w-1/2" label="Cor degradê" style="padding:0" type="color" />

        </div>

        <SocialMedia :value="form.social_media" />

        <h2 class="text-2xl font-bold text-indigo-600 -mb-8 -mr-6 p-8">IMAGES</h2>
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <file-input v-model="form.logo" :error="form.errors.logo" class="pb-8 pr-6 w-full lg:w-1/2" type="file"
            accept="image/*" label="Logotipo" :link="organization?.images?.logo" />
          <file-input v-model="form.logoMenu" :error="form.errors.logoMenu" class="pb-8 pr-6 w-full lg:w-1/2"
            type="file" accept="image/*" label="Logotipo Menu" :link="organization?.images?.logoMenu" />
          <file-input v-model="form.iconManifest" :error="form.errors.iconManifest" class="pb-8 pr-6 w-full lg:w-1/2"
            type="file" accept="image/png" label="Icon PWA" :link="organization?.images?.iconManifest" />
          <file-input v-model="form.background" :error="form.errors.background" class="pb-8 pr-6 w-full lg:w-1/2"
            type="file" accept="image/*" label="Background" :link="organization?.images?.background" />
          <file-input v-model="form.backgroundMobile" :error="form.errors.backgroundMobile"
            class="pb-8 pr-6 w-full lg:w-1/2" type="file" accept="image/*" label="Background Mobile"
            :link="organization?.images?.backgroundMobile" />
        </div>

        <h2 class="text-2xl font-bold text-indigo-600 -mb-8 -mr-6 p-8">SMTP</h2>
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input v-model="form.smtp.host" :error="form.errors['smtp.host']" class="pb-8 pr-6 w-full lg:w-1/2"
            label="Host" />
          <text-input v-model="form.smtp.port" :error="form.errors['smtp.port']" class="pb-8 pr-6 w-full lg:w-1/2"
            label="Port" />
          <text-input v-model="form.smtp.username" :error="form.errors['smtp.username']"
            class="pb-8 pr-6 w-full lg:w-1/2" label="User" />
          <text-input v-model="form.smtp.password" :error="form.errors['smtp.password']"
            class="pb-8 pr-6 w-full lg:w-1/2" label="Password" type="password" />
          <text-input v-model="form.smtp.encryption" :error="form.errors['smtp.encryption']"
            class="pb-8 pr-6 w-full lg:w-1/2" label="Encryption" placeholder="tls" />
          <text-input v-model="form.smtp.from_name" :error="form.errors['smtp.from_name']"
            class="pb-8 pr-6 w-full lg:w-1/2" label="From Name" />
          <text-input v-model="form.smtp.from_address" :error="form.errors['smtp.from_address']"
            class="pb-8 pr-6 w-full lg:w-1/2" label="From Address" />
          <text-input v-model="form.smtp.mail_copy_cadastro" :error="form.errors['smtp.mail_copy_cadastro']"
            class="pb-8 pr-6 w-full lg:w-1/2" label="Mail Copy - Novo Cadastro" />
          <text-input v-model="form.smtp.mail_copy_pedido" :error="form.errors['smtp.mail_copy_pedido']"
            class="pb-8 pr-6 w-full lg:w-1/2" label="Mail Copy - Novo Pedido" />
          <text-input v-model="form.smtp.mail_copy_pagamento" :error="form.errors['smtp.mail_copy_pagamento']"
            class="pb-8 pr-6 w-full lg:w-1/2" label="Mail Copy - Pagamento Confirmado" />
          <text-input v-model="form.smtp.mail_copy_saque" :error="form.errors['smtp.mail_copy_saque']"
            class="pb-8 pr-6 w-full lg:w-1/2" label="Mail Copy - Saque" />
        </div>

        <h2 class="text-2xl font-bold text-indigo-600 -mb-8 -mr-6 p-8">FATURAMENTO</h2>
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">

          <text-input v-model="form.faturamento_config.uforigem" :error="form.errors['faturamento_config.uforigem']"
            class="pb-8 pr-6 w-full lg:w-1/2" label="UF de Origem" />
          <text-input v-model="form.faturamento_config.cfop_est_pj"
            :error="form.errors['faturamento_config.cfop_est_pj']" class="pb-8 pr-6 w-full lg:w-1/2"
            label="CFOP Destinatário PJ Dentro Estado" />
          <text-input v-model="form.faturamento_config.cfop_est_pf"
            :error="form.errors['faturamento_config.cfop_est_pf']" class="pb-8 pr-6 w-full lg:w-1/2"
            label="CFOP Destinatário PF Dentro Estado" />
          <text-input v-model="form.faturamento_config.cfop_est_bon"
            :error="form.errors['faturamento_config.cfop_est_bon']" class="pb-8 pr-6 w-full lg:w-1/2"
            label="CFOP Bonificação Dentro Estado" />
          <text-input v-model="form.faturamento_config.cfop_int_pj"
            :error="form.errors['faturamento_config.cfop_int_pj']" class="pb-8 pr-6 w-full lg:w-1/2"
            label="CFOP Destinatário PJ Interestadual" />
          <text-input v-model="form.faturamento_config.cfop_int_pf"
            :error="form.errors['faturamento_config.cfop_int_pf']" class="pb-8 pr-6 w-full lg:w-1/2"
            label="CFOP Destinatário PF Interestadual" />
          <text-input v-model="form.faturamento_config.cfop_int_bon"
            :error="form.errors['faturamento_config.cfop_int_bon']" class="pb-8 pr-6 w-full lg:w-1/2"
            label="CFOP Bonificação Interestadual" />
        </div>

        <h2 class="text-2xl font-bold text-indigo-600 -mb-8 -mr-6 p-8">INTEGRAÇÃO ZETTAERP</h2>
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input v-model="form.zettaerp_config.url" :error="form.errors['zettaerp_config.url']"
            class="pb-8 pr-6 w-full lg:w-1/1" label="URL" />
          <text-input v-model="form.zettaerp_config.emp_cod" :error="form.errors['zettaerp_config.emp_cod']"
            class="pb-8 pr-6 w-full lg:w-1/2" label="Código Empresa ERP" />
          <text-input v-model="form.zettaerp_config.client_id" :error="form.errors['zettaerp_config.client_id']"
            class="pb-8 pr-6 w-full lg:w-1/2" label="Client ID" />
          <text-input v-model="form.zettaerp_config.client_secret" :error="form.errors['zettaerp_config.client_secret']"
            class="pb-8 pr-6 w-full lg:w-1/1" label="Client SECRET" />
          <select-input v-model="form.zettaerp_config.status" :error="form.errors['zettaerp_config.status']"
            class="pb-8 pr-6 w-full lg:w-1/2" label="Status">
            <option :value="null" />
            <option value="on">ligada</option>
            <option value="off">desligada</option>
          </select-input>
        </div>

        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <span class="pb-8 pr-6 w-full lg:w-1/1">
            <label><b>Parâmetros dos Pedidos ZettaERP</b></label>
          </span>
          <text-input v-model="form.zettaerp_params.pedido_prefixo_numero"
            :error="form.errors['zettaerp_params.pedido_prefixo_numero']" class="pb-8 pr-6 w-full lg:w-1/2"
            label="Prefixo Número Pedido" />
          <text-input v-model="form.zettaerp_params.pedido_serie_modelo"
            :error="form.errors['zettaerp_params.pedido_serie_modelo']" class="pb-8 pr-6 w-full lg:w-1/2"
            label="Série Modelo" />
          <text-input v-model="form.zettaerp_params.pedido_tabela_contabil_avista"
            :error="form.errors['zettaerp_params.pedido_tabela_contabil_avista']" class="pb-8 pr-6 w-full lg:w-1/2"
            label="Tabela Contábil Venda à Vista" />
          <text-input v-model="form.zettaerp_params.pedido_tabela_contabil_aprazo"
            :error="form.errors['zettaerp_params.pedido_tabela_contabil_aprazo']" class="pb-8 pr-6 w-full lg:w-1/2"
            label="Tabela Contábil Venda à Prazo" />
          <text-input v-model="form.zettaerp_params.pedido_forma_pagamento_avista"
            :error="form.errors['zettaerp_params.pedido_forma_pagamento_avista']" class="pb-8 pr-6 w-full lg:w-1/2"
            label="Forma Pagamento Venda à Vista" />
          <text-input v-model="form.zettaerp_params.pedido_forma_pagamento_aprazo"
            :error="form.errors['zettaerp_params.pedido_forma_pagamento_aprazo']" class="pb-8 pr-6 w-full lg:w-1/2"
            label="Forma Pagamento Venda à Prazo" />
          <text-input v-model="form.zettaerp_params.pedido_tipo_pagamento_avista"
            :error="form.errors['zettaerp_params.pedido_tipo_pagamento_avista']" class="pb-8 pr-6 w-full lg:w-1/2"
            label="Tipo Pagamento Venda à Vista" />
          <text-input v-model="form.zettaerp_params.pedido_tipo_pagamento_aprazo"
            :error="form.errors['zettaerp_params.pedido_tipo_pagamento_aprazo']" class="pb-8 pr-6 w-full lg:w-1/2"
            label="Tipo Pagamento Venda à Prazo" />
          <text-input v-model="form.zettaerp_params.pedido_cond_pagamento_avista"
            :error="form.errors['zettaerp_params.pedido_cond_pagamento_avista']" class="pb-8 pr-6 w-full lg:w-1/2"
            label="Condição Pagamento Venda à Vista" />
          <text-input v-model="form.zettaerp_params.pedido_cond_pagamento_aprazo"
            :error="form.errors['zettaerp_params.pedido_cond_pagamento_aprazo']" class="pb-8 pr-6 w-full lg:w-1/2"
            label="Condição Pagamento Venda à Prazo" />
          <text-input v-model="form.zettaerp_params.pedido_tabela_contabil_bonif"
            :error="form.errors['zettaerp_params.pedido_tabela_contabil_bonif']" class="pb-8 pr-6 w-full lg:w-1/2"
            label="Tabela Contábil Bonificação" />
          <text-input v-model="form.zettaerp_params.pedido_tipo_pagamento_bonif"
            :error="form.errors['zettaerp_params.pedido_tipo_pagamento_bonif']" class="pb-8 pr-6 w-full lg:w-1/2"
            label="Tipo Pagamento Bonificação" />
          <text-input v-model="form.zettaerp_params.pedido_vendedor"
            :error="form.errors['zettaerp_params.pedido_vendedor']" class="pb-8 pr-6 w-full lg:w-1/2"
            label="Vendedor" />
          <text-input v-model="form.zettaerp_params.pedido_tipo_frete"
            :error="form.errors['zettaerp_params.pedido_tipo_frete']" class="pb-8 pr-6 w-full lg:w-1/2"
            label="Tipo Frete" />
          <text-input v-model="form.zettaerp_params.pedido_observacoes"
            :error="form.errors['zettaerp_params.pedido_observacoes']" class="pb-8 pr-6 w-full lg:w-1/2"
            label="Observações" />
        </div>

        <h2 class="text-2xl font-bold text-indigo-600 -mb-8 -mr-6 p-8">INTEGRAÇÃO GERENCIANET</h2>
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input v-model="form.gnet_public_token" :error="form.errors.gnet_public_token"
            class="pb-8 pr-6 w-full lg:w-1/2" label="Token GerenciaNet" />
        </div>

        <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
          <button v-if="!organization.deleted_at" class="text-red-600 hover:underline" tabindex="-1" type="button"
            @click="destroy">Excluir Organização</button>
          <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">Salvar
          </loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import FileInput from '@/Shared/FileInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'
import SocialMedia from './SocialMedia';

export default {
  components: {
    Head,
    Icon,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
    TrashedMessage,
    FileInput,
    SocialMedia
  },
  layout: Layout,
  props: {
    organization: Object,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        name: this.organization.name,
        code: this.organization.code,
        urls: (this.organization.urls || []).join(','),
        status: this.organization.status,
        site_official: this.organization.site_official,
        smtp: this.organization.smtp || { host: "" },
        social_media: this.organization.social_media || [],
        zettaerp_config: this.organization.zettaerp_config || { status: "desligada" },
        zettaerp_params: this.organization.zettaerp_params || {
          pedido_prefixo_numero: "DIGLOJA-",
          pedido_serie_modelo: "001-55",
          pedido_tabela_contabil_avista: "",
          pedido_tabela_contabil_aprazo: "",
          pedido_tabela_contabil_bonif: "",
          pedido_forma_pagamento_avista: "",
          pedido_forma_pagamento_aprazo: "",
          pedido_tipo_pagamento_avista: "",
          pedido_tipo_pagamento_aprazo: "",
          pedido_tipo_pagamento_bonif: "",
          pedido_cond_pagamento_avista: "",
          pedido_cond_pagamento_aprazo: "",
          pedido_tipo_frete: "2",
          pedido_vendedor: "1",
          pedido_observacoes: ""
        },
        faturamento_config: this.organization.faturamento_config || {
          uforigem: "--",
          cfop_est_pj: "5102",
          cfop_est_pf: "5102",
          cfop_est_bon: "5910",
          cfop_int_pj: "6102",
          cfop_int_pf: "6102",
          cfop_int_bon: "6910"
        },
        theme: this.organization.theme || { primary_color: "#074e98", secondary_color: "#177ce8", degrade_color: "#177ce8" },
        link_materiais: this.organization.link_materiais,
        link_catalogo: this.organization.link_catalogo,
        link_suporte: this.organization.link_suporte,
        registration_type: this.organization.registration_type,
        gnet_public_token: this.organization.gnet_public_token,
        logo: null,
        logoMenu: null,
        iconManifest: null,
        background: null,
        backgroundMobile: null,
        modelo_multinivel: this.organization.modelo_multinivel,
      }),
    }
  },
  methods: {
    update() {
      this.form
        .transform((data) => ({
          ...data,
          urls: data.urls?.split(',').map(s => s.trim()) || [],
        }))
        .post(`/organizations/${this.organization.id}`, {
          onSuccess: () => this.form.reset('logo'),
        })
    },
    destroy() {
      if (confirm('Are you sure you want to delete this organization?')) {
        this.$inertia.delete(`/organizations/${this.organization.id}`)
      }
    },
    restore() {
      if (confirm('Are you sure you want to restore this organization?')) {
        this.$inertia.put(`/organizations/${this.organization.id}/restore`)
      }
    },
  },
}
</script>
